module.exports = __webpack_public_path__ + "img/antes_despues_74.4cc52e13.png";